<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('legalnotice.Header') }}</h2>
                <h3>{{ $t('legalnotice.Board') }}</h3>
                <strong>{{ $t('legalnotice.1Board') }}</strong> Veysi Ergenc<br />
                <strong>{{ $t('legalnotice.2Board') }}</strong> Hans-J&uuml;rgen Schulz<br />
                <strong>{{ $t('legalnotice.CEO') }}</strong> Daniel Sobottka<br />
                <h3>{{ $t('legalnotice.MailingAdress') }}</h3>
                Taekwondo Sportgemeinschaft Bochum e.V.<br />
                Weilenbrink 9<br />
                44787 Bochum<br />
                <h3>{{ $t('legalnotice.Contact') }}</h3>
                <strong>{{ $t('legalnotice.Phone') }}</strong> 0234 / 53 05 31 14
                <br />
                <strong>E-Mail:</strong><a href="mailto:info@tsg-bochum.de"><b> info@tsg-bochum.de</b></a>
                <br />
                <br />
                <strong>{{ $t('legalnotice.AssociationregisterNumber') }}</strong> VR 2908 / Taekwondo Sportgemeinschaft Bochum e.V. / {{ $t('legalnotice.DistrictCourt') }}
                <br />
                <strong>{{ $t('legalnotice.TaxNumber') }}</strong> 306 / 5804 / 0037 {{ $t('legalnotice.NonProfitAssociation') }}
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';

    export default {
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>